module.exports = require("core-js-pure/stable/promise");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/promise.js
// module id = 10
// module chunks = 0 1